import { Button, Card } from "semantic-ui-react";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useCollectionData } from "astrid-firestore/src/hooks";

import Flex from "../../../../../components/Flex/Flex";
import useCostsQuery from "../../../../costs/hooks/useCostsQuery";
import LoadingContext from "../../../../ui/components/LoadingContext/LoadingContext";

import OrderDetails from "../../../components/OrderDetails/OrderDetails";

import OrderEmailForm from "./OrderEmailForm";

export default function OrderInfo({ order, organization }) {
	const { t } = useTranslation();

	const [openModal, setOpenModal] = useState(false);

	const costsQuery = useCostsQuery({ orderId: order.id });

	const [costs = [], loading, error] = useCollectionData(order && costsQuery);

	const handleExport = () => {
		if (order.excel?.url) window.open(order.excel.url, "_blank");
	};

	return (
		<>
			<Card fluid>
				<Card.Content>
					<Card.Header>{order.id}</Card.Header>
				</Card.Content>

				<Card.Content extra>
					{order.expense ? t("resource") : t("publisher")}

					<Card.Meta>{order.secondParty?.name}</Card.Meta>
				</Card.Content>

				{order.created?.toDate && (
					<Card.Content extra>
						{t("date", "Date")}

						<Card.Meta>{order.created.toDate().toLocaleString()}</Card.Meta>
					</Card.Content>
				)}

				<Card.Content>
					<LoadingContext data={costs} loading={loading} error={error}>
						<OrderDetails order={order} costs={costs} />

						<Flex gap={5} justifyContent="flex-end">
							<Button floated="right" onClick={handleExport}>
								{t("exportAsExcel", "Export as excel")}
							</Button>

							{!order.expense && (
								<Button primary floated="right" onClick={() => setOpenModal(true)}>
									{t("sendToFinance", "Send to finance")}
								</Button>
							)}
						</Flex>
					</LoadingContext>
				</Card.Content>
			</Card>

			{openModal && (
				<OrderEmailForm organization={organization} order={order} onClose={() => setOpenModal(false)} />
			)}
		</>
	);
}
